import { Box, Typography, Button, Paper } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

const certificate_url = process.env.REACT_APP_CERTIFICADO_URL;

export default function VaccinationCodeCard({ code = "No disponible" }) {
  return (
    <Box style={{ marginBottom: 32 }}>
      <Paper
        elevation={3}
        style={{
          maxWidth: 480,
          margin: "auto",
          padding: 24,
          borderRadius: 16,
          textAlign: "center",
        }}
      >
        <CheckCircleIcon style={{ fontSize: 48, color: "#2ecc71" }} />

        <Typography variant="h6" style={{ marginTop: 12, fontWeight: 500 }}>
          Sus datos han sido verificados. El código asignado a usted es:
        </Typography>

        <Box
          style={{
            margin: "16px 0",
            display: "inline-block",
            background: "#f7f7f7",
            padding: "8px 24px",
            fontSize: "1.2rem",
            fontWeight: 600,
            borderRadius: 8,
            border: "1px solid #ccc",
          }}
        >
          {code}
        </Box>

        <Typography style={{ marginBottom: 16 }}>
          Este código será utilizado para generar su Certificado de Vacunación.<br />
          Para utilizar su código y generar su Certificado de Vacunación, favor dar clic al botón.
        </Typography>

        <Button
          variant="contained"
          color="primary"
          fullWidth
          style={{ borderRadius: 50, padding: "12px 0" }}
          href={certificate_url}
        >
          Obten tu certificado de vacunación
        </Button>
      </Paper>
    </Box>
  );
}
